import { render, staticRenderFns } from "./CustomerServiceIcon.vue?vue&type=template&id=50dbd7e0&scoped=true"
import script from "./CustomerServiceIcon.vue?vue&type=script&lang=js"
export * from "./CustomerServiceIcon.vue?vue&type=script&lang=js"
import style0 from "./CustomerServiceIcon.vue?vue&type=style&index=0&id=50dbd7e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dbd7e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50dbd7e0')) {
      api.createRecord('50dbd7e0', component.options)
    } else {
      api.reload('50dbd7e0', component.options)
    }
    module.hot.accept("./CustomerServiceIcon.vue?vue&type=template&id=50dbd7e0&scoped=true", function () {
      api.rerender('50dbd7e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomerServiceIcon.vue"
export default component.exports